export default "__VITE_ASSET__BPx3lqp___"